import FilterIndicator from './filter-indicator';

export default FilterIndicator;